export default __webpack_public_path__ + "static/media/icon-csv-inactive.5e3c57e5.svg";